module.exports = __webpack_public_path__ + "static/img/pres-op--std.2eaceb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pres-op--std.png
// module id = q6NL
// module chunks = 1